module.exports = __webpack_public_path__ + "img/parcel-picked-up.b9bd5212.svg";